function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=414&deploy=1&compid=433345&ns-at=AAEJ7tMQiWrv_zh7CrCc56VTAx2aIKJ-MfjFOBda_lds3mz_OT4","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=513&deploy=1&compid=433345&ns-at=AAEJ7tMQIWe7VuDE3Zq9uc_A_MDzze4E-GEGPAFr-CFwEgGRbvo","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=1433&deploy=1&compid=433345&ns-at=AAEJ7tMQ8pdZMriNYCncdHDh_KRYCORNiQkiY70HVvLnCJ72_dg","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=359&deploy=1&compid=433345&ns-at=AAEJ7tMQdcw8shItrZEjwJrrbMgbDeDtBSc3VEML9KBxp7BWXRw","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=361&deploy=1&compid=433345&ns-at=AAEJ7tMQbqfQ8ZNUySHK3Vh9PudcHZQl0fXhGdxaACH2WIwhtpw","customscript_ns_sc_sl_productleadtime:customdeploy_ns_sc_sl_productleadtime":"/app/site/hosting/scriptlet.nl?script=356&deploy=1&compid=433345&ns-at=AAEJ7tMQ7SY5UG2vyh72ioo_kY-zvk_9CB9pXUk-x4wGJQFPvbg"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}